/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ChargePointMetadataDto
 */
export interface ChargePointMetadataDto {
    /**
     *
     * @type {string}
     * @memberof ChargePointMetadataDto
     */
    chargerType?: ChargePointMetadataDtoChargerTypeEnum;
    /**
     *
     * @type {string}
     * @memberof ChargePointMetadataDto
     */
    managedBy?: ChargePointMetadataDtoManagedByEnum;
    /**
     *
     * @type {string}
     * @memberof ChargePointMetadataDto
     */
    metadata?: string;
    /**
     *
     * @type {string}
     * @memberof ChargePointMetadataDto
     */
    thirdPartyDeviceIdentity?: string;
}

/**
 * @export
 */
export const ChargePointMetadataDtoChargerTypeEnum = {
    OcppUnknown: "OcppUnknown",
    ChargeMate: "ChargeMate",
    Tesla: "Tesla",
    Quasar: "Quasar",
} as const;
export type ChargePointMetadataDtoChargerTypeEnum =
    (typeof ChargePointMetadataDtoChargerTypeEnum)[keyof typeof ChargePointMetadataDtoChargerTypeEnum];

/**
 * @export
 */
export const ChargePointMetadataDtoManagedByEnum = {
    ChargefoxDev: "ChargefoxDev",
    ChargefoxStaging: "ChargefoxStaging",
    ChargefoxProd: "ChargefoxProd",
    Illuminate: "Illuminate",
    Exploren: "Exploren",
    Fortum: "Fortum",
    ChargeHq: "ChargeHq",
    DynamicPassthroughParent: "DynamicPassthroughParent",
    DynamicPassthroughChild: "DynamicPassthroughChild",
    GatewayDynamicPassthroughChild: "GatewayDynamicPassthroughChild",
    ServerlessFunctionApp: "ServerlessFunctionApp",
} as const;
export type ChargePointMetadataDtoManagedByEnum =
    (typeof ChargePointMetadataDtoManagedByEnum)[keyof typeof ChargePointMetadataDtoManagedByEnum];

/**
 * Check if a given object implements the ChargePointMetadataDto interface.
 */
export function instanceOfChargePointMetadataDto(
    value: object,
): value is ChargePointMetadataDto {
    return true;
}

export function ChargePointMetadataDtoFromJSON(
    json: any,
): ChargePointMetadataDto {
    return ChargePointMetadataDtoFromJSONTyped(json, false);
}

export function ChargePointMetadataDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ChargePointMetadataDto {
    if (json == null) {
        return json;
    }
    return {
        chargerType:
            json["chargerType"] == null ? undefined : json["chargerType"],
        managedBy: json["managedBy"] == null ? undefined : json["managedBy"],
        metadata: json["metadata"] == null ? undefined : json["metadata"],
        thirdPartyDeviceIdentity:
            json["thirdPartyDeviceIdentity"] == null
                ? undefined
                : json["thirdPartyDeviceIdentity"],
    };
}

export function ChargePointMetadataDtoToJSON(
    value?: ChargePointMetadataDto | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        chargerType: value["chargerType"],
        managedBy: value["managedBy"],
        metadata: value["metadata"],
        thirdPartyDeviceIdentity: value["thirdPartyDeviceIdentity"],
    };
}
